import { Coin, Dec, Numeric, Denom } from '../../../core';
import { BaseAPI } from './BaseAPI';
import { TaxRate } from '../../../core/market/params';
import { Convert } from '../../../util/convert';

export interface MarketParams {
  pool_recovery_period: number;
  base_pool: Dec;
  min_spread: Dec;
  tobin_tax: Dec;
  illiquid_tobin_tax_list: TaxRate[];
}

export namespace MarketParams {
  export interface Data {
    pool_recovery_period: string;
    base_pool: string;
    min_spread: string;
    tobin_tax: string;
    illiquid_tobin_tax_list: TaxRate.Data[];
  }
}

export class MarketAPI extends BaseAPI {
  public async swapRate(offerCoin: Coin, askDenom: Denom): Promise<Coin> {
    let params = {
      offer_coin: offerCoin.toString(),
      ask_denom: askDenom,
    };

    return this.c
      .get<Coin.Data>(`/market/swap`, params)
      .then(d => Coin.fromData(d.result));
  }

  public async terraPoolDelta(): Promise<Dec> {
    return this.c
      .get<Numeric.Input>(`/market/terra_pool_delta`)
      .then(d => new Dec(d.result));
  }

  public async parameters(): Promise<MarketParams> {
    return this.c
      .get<MarketParams.Data>(`/market/parameters`)
      .then(d => d.result)
      .then(d => ({
        pool_recovery_period: Number.parseInt(d.pool_recovery_period),
        base_pool: new Dec(d.base_pool),
        min_spread: new Dec(d.min_spread),
        tobin_tax: new Dec(d.tobin_tax),
        illiquid_tobin_tax_list: Convert.toTaxRateArray(
          d.illiquid_tobin_tax_list
        ),
      }));
  }
}
